import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Rx';

import { EventsBusService } from '../shared/eventsBus.service';
import { Feedback } from './shared/feedbacks.model';
import { FeedbacksService } from './shared/feedbacks.service';

@Component({
  selector: 'app-feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss']
})
export class FeedbacksComponent implements OnInit {
  feedbacks: Feedback[] = [];
  search = '';
  currentFeedback: Feedback;
  currentFeedbackId: string;
  types: any[] = [];
  from = 0;
  limit = 20;
  isLoading: Boolean = false;
  private _lastFrom = 0;
  public isScroll: Boolean = false;
  public infiniteScroll = '.infiniteScroll';
  private subject: Subject<string> = new Subject();
  statusFilter = '';
  publishFilter = '';
  listStatus: any[] = [
    { state: '', name: 'Tất cả' },
    { state: 'open', name: 'Đã tiếp nhận' },
    { state: 'needInfo', name: 'Cần thêm thông tin' },
    { state: 'reviewed', name: 'Đã kiểm duyệt thông tin' },
    { state: 'approved', name: 'Đã duyệt' },
    { state: 'inProgress', name: 'Đang xử lý' },
    { state: 'resultReceived', name: 'Đã nhận kết quả xử lý' },
    { state: 'done', name: 'Đã xử lý' },
    { state: 'archived', name: 'Lưu trữ' },
    { state: 'cancelled', name: 'Đã hủy' },
    { state: 'closed', name: 'Đã đóng' }
  ];
  listFitler: any[] = [
    { state: '', name: 'Tất cả' },
    { state: 'publish', name: 'Công bố' },
    { state: 'unpublish', name: 'Không công bố' }
  ];
  constructor(private service: FeedbacksService, private router: Router, private eventsBus: EventsBusService) {}

  queryFeedbacks(
    isFrom: number,
    isLimit: number,
    isStates: string = '',
    isPublish: string = '',
    isText: string = '',
    isReset: boolean = false
  ) {
    this.feedbacks = [];
    this.isLoading = true;
    if (isReset) {
      isFrom = this._lastFrom;
    } else {
      this._lastFrom = isFrom;
    }
    this.service
      .query({ from: isFrom, limit: isLimit, states: isStates, publish: isPublish, text: isText })
      .subscribe(feedbacks => {
        this.from += feedbacks.length;
        this.feedbacks = feedbacks;
        this.isLoading = false;
      });
  }
  getFeedbacks() {
    this.queryFeedbacks(this.from, this.limit);
  }

  getMoreFeedbacks() {
    this.isScroll = true;
    this.service
      .query({ from: this.from, limit: this.limit, states: this.statusFilter, text: this.search })
      .subscribe(feedbacks => {
        this.from += feedbacks.length;
        this.feedbacks = this.feedbacks.concat(feedbacks);
        this.isScroll = false;
      });
  }

  ngOnInit() {
    this.getFeedbacks();
    this.subject.debounceTime(500).subscribe(() => {
      this.queryFeedbacks(this.from, this.limit, this.statusFilter, this.publishFilter, this.search);
    });
    this.eventsBus.updateFeedback.subscribe(() => {
      this.resetList();
    });
    this.service
      .getAllTypes()
      .do(types => (this.types = types))
      .subscribe();
  }

  resetList() {
    this.queryFeedbacks(this.from, this.limit, this.statusFilter, this.publishFilter, this.search, true);
  }

  getTypeValue(id, key) {
    let value = '';
    if (this.types.length > 0) {
      this.types.forEach(type => {
        if (id === type._id) {
          value = type[key];
        }
      });
    }
    return value;
  }

  chooseFeedback(feedback: Feedback) {
    this.currentFeedback = feedback;
    this.currentFeedbackId = feedback._id;
    this.router.navigate([feedback._id]);
  }

  filterFeedbacksByStatus(state: string) {
    this.statusFilter = state;
    this.from = 0;
    this.queryFeedbacks(this.from, this.limit, this.statusFilter, this.publishFilter, this.search);
  }
  filterFeedbacksByPublish(state: string) {
    this.publishFilter = state;
    this.from = 0;
    this.queryFeedbacks(this.from, this.limit, this.statusFilter, this.publishFilter, this.search);
  }

  searchFeedbacks() {
    if (this.search === '' || this.search.length > 3) {
      this.from = 0;
      this.subject.next(this.search);
    }
  }

  onScrolled(e) {
    this.getMoreFeedbacks();
  }

  clearSearch() {
    this.search = '';
    this.from = 0;
    this.queryFeedbacks(this.from, this.limit, this.statusFilter, this.publishFilter, this.search);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedbacks.component.ts